<div class="tab-content">
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">

        <div class="hero-text" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'COMPANY_ADDITION_FORM'|translate}}</h1>
        </div>


        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'NAME'|translate}}</mat-label>
            <input matInput placeholder="{{'NAME'|translate}}" name="name" [(ngModel)]="model.name" required>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'DESCRIPTION'|translate}}</mat-label>
            <input matInput placeholder="{{'DESCRIPTION'|translate}}" name="desc" [(ngModel)]="model.description">
        </mat-form-field>
        
        <div class="w-100-p pb-24">
            <button mat-raised-button (click)="globalConfigClick(model)">
                <span>{{'COMPANY_CONFIG'|translate}}</span>
            </button>
        </div>

        <button mat-raised-button (click)="save()">
            <span>{{'CREATE'|translate}}</span>
        </button>
    </form>
</div>